<template>
  <div class="d-flex">
    <div v-if="absence.lock" class="d-flex flex-column align-center justify-center">
      <v-icon color="error">mdi-lock-outline</v-icon>
      <div style="font-size: 7px">{{ absence.lock.firstName }} {{ absence.lock.lastName }}</div>
    </div>
    <template v-else>
      <v-btn v-if="isDevEnv || mx_isZueri9View" :disabled="isDisabled" small icon @click="$emit('copyAction', absence)">
        <v-icon small title="Zeile kopieren">mdi-content-copy</v-icon>
      </v-btn>
      <v-btn v-if="!absence.deleted && !mx_isZueri9CustomerView" :disabled="isDisabled" @click="$emit('editAction', absence)" small icon>
        <v-icon small title="editieren">mdi-pencil</v-icon>
      </v-btn>
      <v-btn v-if="isDeletionEnabled" small icon @click="$emit('deleteAction', absence)">
        <v-icon small :title="absence.deleted ? 'reaktivieren' : 'löschen'" class="mx-1">
          {{ absence.deleted ? 'mdi-delete-off' : 'mdi-delete' }}
        </v-icon>
      </v-btn>
      <v-btn small icon v-if="!isAssignedToDifferentView && mx_isDispoView" @click="$emit('forwardAction', absence)" :disabled="isDisabled"
        ><v-icon small title="Weiterleiten">mdi-share</v-icon>
      </v-btn>
      <v-btn v-else-if="mx_isDispoView && isAssignedToDifferentView" @click="$emit('restoreAction', absence)" small icon>
        <v-icon small title="Zurücknehmen">mdi-restore</v-icon>
      </v-btn>
      <div v-if="mx_isDispoView && absence.vbzNr" @click.prevent.stop="$emit('mailAction', absence)" :id="`mail_${absence.id}`">
        <v-icon small title="Mail versenden"> mdi-mail </v-icon>
      </div>
    </template>
  </div>
</template>
<script>
import wsMixin from '@/modules/customerVbzWorksheet/wsMixin';

export default {
  name: 'Action',
  mixins: [wsMixin],
  props: {
    column: Object,
    absence: Object,
    isAssignedToDifferentView: Boolean,
    isDisabled: { type: Boolean, default: false },
  },
  computed: {
    isDevEnv() {
      return process.env.NODE_ENV === 'dev';
    },
    isDeletionEnabled() {
      if (this.mx_isDispoView) {
        return !this.isAssignedToDifferentView;
      } else if (this.mx_isZueri9View) {
        return !this.absence.dispoState; // dispoState is undefined if zueri 9 created the item and thus may be deleted
      } else if (!this.mx_isZueri9CustomerView) {
        return false;
      }
      return false;
    },
  },
};
</script>
